import { render } from "./index-import.vue?vue&type=template&id=f95bdad8"
import script from "./index-import.vue?vue&type=script&lang=js"
export * from "./index-import.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__